import TableSkeleton from "./TableSkeleton";
import TabsSkeleton from "./TabsSkeleton";
import { Card } from "@medentic/polaris-react";

function TabsTableSkeleton() {
  return (
    <Card roundedAbove="sm" padding={"0"}>
      <TabsSkeleton />
      <TableSkeleton />
    </Card>
  );
}

export default TabsTableSkeleton;
